import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { BtnCellRendererDetailsDelete } from 'src/app/core/grid/btn-cell-render-details-delete';
import { SummaryService } from 'src/app/service/asn/summary.service';
import { ExcelService } from 'src/app/service/excel.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-asn-summary',
    templateUrl: './asn-summary.component.html',
    styleUrls: ['./asn-summary.component.scss'],
    standalone: false
})
export class ASNSummaryComponent implements OnInit {

  gridApi: any;
  successMessage: string;
  errorMessage: string;
  columnDefs = [];
  displayRowData = [];
  currentPageNo: number;
  currentPageBoolean: boolean = false;
  totalPage: number;
  currentPageForTotalPage: number;
  isLastPageFound: boolean;
  rowCount: number;
  defaultColDef: {};
  gridOptions
  icons: {};
  userID: number
  context: {};
  isAccessible = false;
  
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]

  constructor(private readonly router: Router, private readonly dialog: MatDialog, private readonly summaryService: SummaryService, private readonly excelService: ExcelService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.columnDefs = [
      {
        headerName: "IMPORTED DATE", field: "createdTime", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, width: 100, comparator: this.dateComparator
      },
      {
        headerName: "SUPPLIER", field: "supplier", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, width: 100,
      },
      {
        headerName: "INVOICE#", field: "invoiceNum", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, width: 100,
      },
      {
        headerName: "KG MATCH", field: "kgVariance", sortable: true, unSortIcon: true, width: 100, cellStyle: this.cellStyling
      },
      {
        headerName: "QTY MATCH", field: "qtVariance", sortable: true, unSortIcon: true, width: 100, cellStyle: this.cellStyling
      },
      {
        headerName: "PO SCHEDULE", field: "poSchedule", sortable: true, unSortIcon: true, width: 100,
        cellStyle: this.cellStyling
      },
      {
        headerName: "ACTIONS", field: "summary_detailsdelete", cellRenderer: BtnCellRendererDetailsDelete, width: 100,
      }];
    // this.checkRoles();
    this.RefreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  cellStyling(params) {
    if (params.value == "NG" || params.value == "Over") {  // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    } 
    if (params.value == "Short") { // NOSONAR
      return { 'background-color': 'yellow', 'color': 'black' };
    }
    return {}
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0; 
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)
    // ) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  RefreshData(): void {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.summaryService.loadDataSummary().subscribe(
      response => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.gridApi?.redrawRows();
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  onBtExport(): void {
    if (this.displayRowData?.length > 0) {
      const headers = ['Imported Date', 'Supplier', 'Invoice', 'KG Match', 'QT Match', 'PO Schedule'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
        {linkData = this.displayRowData}
      linkData.forEach(e => {
        const obj = {
          ImportedDate: e.createdTime,
          Supplier: e.supplier,
          Invoice: e.invoiceNum,
          KGMatch: e.kgVariance,
          QTMatch: e.qtVariance,
          POSchedule: e.poSchedule,
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'ASN-SUMMARY', headers);
    }
  }

  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeletePalletDialogComponent, {
      disableClose: true,
      width: 'max-content',
      data: {
        header: 'Are you sure you want to delete this ASN-Summary ?',
        description: `Invoice : ${data.invoiceNum}`,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'ConfirmEvent') { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.summaryService.deleteSummary(data.invoiceNum).subscribe(
          response => {

            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.RefreshData();
            } else {
              this.errorMessage = response;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
            }

          }, _error => {

            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }
        );
      }
    });
  }

  detailsTemplateRow(data, _pagename) {
    if (data.invoiceNum && data.supplier) {
      const summaryObject = {
        invoiceNumber: data.invoiceNum,
        supplier: data.supplier
      };
      localStorage.setItem('summary-details', JSON.stringify(summaryObject));
      this.openRouteLevel('summary/summary-details')

    } else {
      this.errorMessage = "Error with Invoice number or Supplier.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route): void {
    this.router.navigate([`${route}`]);
  }

}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}